<template>
    <div class="box" :style="{ backgroundImage: 'url(' + img + ')' }">
        <div class="box-cont">
            <div class="title reveal-bottom">{{ $t("h.feature_t") }}</div>
            <div class="feature-wrap reveal-bottom">
                <div class="feature-item">
                    <div class="feature-an">
                        <div class="bg-cont">
                            {{ $t("h.feature_d_1") }}
                        </div>
                        <div class="bg">
                            <img
                                class="bg-icon"
                                :src="
                                    require('@/assets/img_svg/home_spec_icon_1.svg')
                                "
                                alt="svg"
                            />

                            <span>{{ $t("h.feature_1") }}</span>
                        </div>
                    </div>
                </div>
                <div class="feature-item">
                    <div class="feature-an">
                        <div class="bg-cont">
                            {{ $t("h.feature_d_2") }}
                        </div>
                        <div class="bg">
                            <img
                                class="bg-icon"
                                :src="
                                    require('@/assets/img_svg/home_spec_icon_2.svg')
                                "
                                alt="svg"
                            />
                            <span>{{ $t("h.feature_2") }}</span>
                        </div>
                    </div>
                </div>
                <div class="feature-item">
                    <div class="feature-an">
                        <div class="bg-cont">
                            {{ $t("h.feature_d_3") }}
                        </div>
                        <div class="bg">
                            <img
                                class="bg-icon"
                                :src="
                                    require('@/assets/img_svg/home_spec_icon_3.svg')
                                "
                                alt="svg"
                            />
                            <span>{{ $t("h.feature_3") }}</span>
                        </div>
                    </div>
                </div>
                <div class="feature-item">
                    <div class="feature-an">
                        <div class="bg-cont">
                            {{ $t("h.feature_d_4") }}
                        </div>
                        <div class="bg">
                            <img
                                class="bg-icon"
                                :src="
                                    require('@/assets/img_svg/home_spec_icon_4.svg')
                                "
                                alt="svg"
                            />
                            <span>{{ $t("h.feature_4") }}</span>
                        </div>
                    </div>
                </div>
                <div class="feature-item">
                    <div class="feature-an">
                        <div class="bg-cont">
                            {{ $t("h.feature_d_5") }}
                        </div>
                        <div class="bg">
                            <img
                                class="bg-icon"
                                :src="
                                    require('@/assets/img_svg/home_spec_icon_5.svg')
                                "
                                alt="svg"
                            />
                            <span>{{ $t("h.feature_5") }}</span>
                        </div>
                    </div>
                </div>
                <div class="feature-item">
                    <div class="feature-an">
                        <div class="bg-cont">
                            {{ $t("h.feature_d_6") }}
                        </div>
                        <div class="bg">
                            <img
                                class="bg-icon"
                                :src="
                                    require('@/assets/img_svg/home_spec_icon_6.svg')
                                "
                                alt="svg"
                            />
                            <span>{{ $t("h.feature_6") }}</span>
                        </div>
                    </div>
                </div>
                <div class="feature-item">
                    <div class="feature-an">
                        <div class="bg-cont">
                            {{ $t("h.feature_d_7") }}
                        </div>
                        <div class="bg">
                            <img
                                class="bg-icon"
                                :src="
                                    require('@/assets/img_svg/home_spec_icon_7.svg')
                                "
                                alt="svg"
                            />
                            <span>{{ $t("h.feature_7") }}</span>
                        </div>
                    </div>
                </div>
                <div class="feature-item">
                    <div class="feature-an">
                        <div class="bg-cont">
                            {{ $t("h.feature_d_8") }}
                        </div>
                        <div class="bg">
                            <img
                                class="bg-icon"
                                :src="
                                    require('@/assets/img_svg/home_spec_icon_8.svg')
                                "
                                alt="svg"
                            />
                            <span>{{ $t("h.feature_8") }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div class="bottom-item flex">
                    <span class="sub-top reveal-bottom">15+</span>
                    <span class="sub-bottom reveal-bottom">{{
                        $t("h.flag")
                    }}</span>
                </div>

                <div class="bottom-middle flex">
                    <span class="sub-top reveal-bottom">100+</span>
                    <span class="sub-bottom reveal-bottom">{{
                        $t("h.flag1")
                    }}</span>
                </div>
                <div class="bottom-item flex">
                    <span class="sub-top reveal-bottom">1000+</span>
                    <span class="sub-bottom reveal-bottom">{{
                        $t("h.flag2")
                    }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            img: require("@/assets/images/home_spec_bg.jpg"),
        };
    },
};
</script>
<style scoped>
.box {
    height: 880px;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-color: #f2f2f2;
}
.box-cont {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    padding: 0 10px;
    box-sizing: border-box;
}
.title {
    font-size: 44px;
    color: #000000;
    text-align: center;
    font-weight: bold;
    line-height: 62px;
    margin-top: 113px;
}
.feature-wrap {
    display: flex;
    flex-wrap: wrap;
    margin-top: 52px;
    justify-content: space-between;
    height: 380px;
}
.feature-item {
    width: 288px;
    height: 180px;
    position: relative;
    background: #fff;
    overflow: hidden;
}
.feature-an {
    /* transform: translateY(-180px); */

    position: relative;
}
.feature-an:hover .bg {
    /* transform: translateY(0); */
    opacity: 0;
}
.feature-an:hover .bg-cont {
    opacity: 1;
}
.bg {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 293px;
    height: 180px;
    text-align: center;
    line-height: 22px;
    color: #333;
    font-size: 16px;
    cursor: default;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 1;
    transition: opacity 0.3s linear;
}
.bg-icon {
    height: 70px;
    margin-bottom: 10px;
}
.bg-cont {
    width: 293px;
    height: 180px;
    padding: 20px;
    box-sizing: border-box;
    background-color: #00a3d1;
    font-size: 16px;
    color: #ffffff;
    line-height: 30px;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    transition: opacity 0.3s linear;
}
.bottom {
    height: 112px;
    display: flex;
    margin-top: 70px;
}
.bottom-middle {
    width: 588px;
    position: relative;
}
.bottom-middle::before {
    content: "";
    width: 1px;
    height: 100%;
    transform: scaleX(0.5);
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.2);
}
.bottom-middle::after {
    content: "";
    width: 1px;
    height: 100%;
    transform: scaleX(0.5);
    position: absolute;
    top: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.2);
}
.bottom-item {
    flex: 1;
}
.flex {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
}
.sub-top {
    font-size: 48px;
    color: #000000;
    line-height: 67px;
    font-weight: bold;
}
.sub-bottom {
    font-size: 14px;
    color: #000000;
    line-height: 21px;
    margin-top: 11px;
    font-weight: bold;
    flex-basis: 81px;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Home/Content1.vue